import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { PopoverDirective } from "ngx-bootstrap/popover";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { BaseComponent } from "app/_components/base.component";
import { AuthenticationService } from "app/_services/authentication.service";
import { ClientService } from "app/_services/client.service";
import { CompanyService } from "app/_services/company.service";
import { SpeakerService } from "app/_services/speaker.service";
import { StaffService } from "app/_services/staff.service";
import { EventService } from "app/_services/event.service";

declare var $: any;

@Component({
  selector: 'app-person-popover',
  templateUrl: './person-popover.component.html',
})
export class PersonPopoverComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() id: string;
  @Input() type: string;
  @ViewChild('pop') pop: PopoverDirective;
  person: any;
  popoverLinkId: string;
  popoverContainerId: string;
  SpeakerConfirmModalRef: BsModalRef;

  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    companyService: CompanyService,
    private staffService: StaffService,
    private speakerService: SpeakerService,
    private clientService: ClientService,
    private modalService: BsModalService,
    private eventService: EventService
  ) {
    super(router, authenticationService, companyService);
  }

  ngOnInit(): void {
    this.popoverLinkId = `popover-link-${this.id}`;
    this.popoverContainerId = `popover-container-${this.id}`;
  }

  ngAfterViewInit() {
    $(document).on('click', (e: any) => {
      if (this.pop.isOpen) {
        const container = $(`#${this.popoverLinkId},#${this.popoverContainerId}`);
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          this.pop.hide();
        }
      }
    });
  }

  onClick() {
    if (this.id == null || this.id === '' || this.id === 'undefined') {
      return;
    }
    if (this.pop.isOpen) {
      this.pop.hide();
      return;
    }
    // Open the popover only after the person (incl. their photo URL) has loaded,
    // otherwise the first click renders with an empty person and shows the
    // placeholder avatar, which then gets replaced once the data arrives.
    if (this.type == 'staff') {
      this.staffService.get(this.id).subscribe((staff) => {
        this.person = staff;
        this.pop.show();
      });
    } else if (this.type == 'area_manager') {
      this.clientService.get(parseInt(this.id), { company_id: this.getCurrentCompanyId() }).subscribe((manager) => {
        this.person = manager;
        this.pop.show();
      });
    } else if (this.type == 'speaker') {
      this.speakerService.get(this.id, { company_id: this.getCurrentCompanyId() }).subscribe((res) => {
        this.person = res.speaker;
        this.pop.show();
      });
    }
  }

  getUrl() {
    if (this.type == 'staff') {
      if (this.person?.agency_id) {
        return '/tools/agency/' + this.person?.agency_id + '/staff/' + this.person?.id + '/edit';
      } else {
        return '/tools/staff/' + this.person?.id + '/edit';
      }
    } else if (this.type == 'area_manager') {
      return this.getCompanyBureauUrl('/tools/area/manager');
    } else if (this.type == 'speaker') {
      return this.getCompanyBureauUrl('/profiles/speakers/' + this.person?.id);
    }
    return '';
  }

  get event() {
    return this.eventService.getCurrentEvent();
  }

  async speakerStatus() {
    const { SpeakerConfirmModalComponent } = await import('../../events/speaker/speaker-confirm-modal.component');
    this.SpeakerConfirmModalRef = this.modalService.show(SpeakerConfirmModalComponent, {
      initialState: {
        companyId: this.getCurrentCompanyId(),
        eventId: this.event.id,
        eventSpeaker: this.getEventSpeaker(),
        speakerSlots: this.getSpeakerSlots(),
      }
    });
    this.SpeakerConfirmModalRef.content.event.subscribe((result) => {
      this.applySpeakerModalResult(result);
    });
    this.pop.toggle();
  }

  private applySpeakerModalResult(result: any) {
    if (!this.event || !result) {
      return;
    }
    const speakers = Array.isArray(this.event.speakers) ? this.event.speakers : [];
    if (result.removed) {
      this.event.speakers = speakers.filter((s) => s.id !== result.speaker_id);
      return;
    }
    if (Array.isArray(result)) {
      this.event.speakers = result;
      return;
    }
    if (result.speakers && Array.isArray(result.speakers)) {
      this.event.speakers = result.speakers;
      return;
    }
    const speaker = speakers.find((s) => s.id === result.speaker_id);
    if (!speaker?.EventSpeaker) {
      return;
    }
    if (result.status) {
      speaker.EventSpeaker.status = result.status;
    }
    if (result.slot != null) {
      speaker.EventSpeaker.slot = result.slot;
    }
  }

  getEventSpeaker() {
    const [speaker] = this.event.speakers.filter((s) => s.id === this.id);
    return speaker.EventSpeaker;
  }

  getSpeakerSlots() {
    return this.event.speakers.map((s) => s.EventSpeaker.slot).sort();
  }
}